const MAX_WAIT_TIME = 300_000; // 5 minutes timeout
const CHECK_INTERVAL = 100; // Check every 100ms
export default async function requestPermission() {
    // Wait for user activation before requesting permission
    const waitForUserActivation = () => {
        return new Promise((resolve, reject) => {
            let elapsedTime = 0;
            const checkActivation = () => {
                if (navigator.userActivation?.isActive) {
                    resolve();
                    return;
                }
                elapsedTime += CHECK_INTERVAL;
                if (elapsedTime >= MAX_WAIT_TIME) {
                    reject(new Error('User activation timeout'));
                    return;
                }
                setTimeout(checkActivation, CHECK_INTERVAL);
            };
            // Start checking immediately
            checkActivation();
        });
    };
    try {
        // Wait for user activation
        await waitForUserActivation();
        // Now request permission
        const result = await Notification.requestPermission();
        return result === 'granted';
    }
    catch (error) {
        console.warn('Failed to request notification permission:', error);
        return false;
    }
}
